import { getCurrentOrCustomerIdProfileSelect } from '../../../profile/redux/selectors/get-current-or-customer-id'
import getByProfileIdDomainListPathReduxUtil from '../../../redux/utils/get-by-profile-id-domain-list-path'

function getDomainListPathWorkoutsSelect (state, path, profileIdParam) {
  const profileId = (
    profileIdParam || getCurrentOrCustomerIdProfileSelect(state)
  )
  return getByProfileIdDomainListPathReduxUtil(path, profileId)
}

export { getDomainListPathWorkoutsSelect }
